import { gql } from '@apollo/client';

export const UPDATE_NC_NOTIFICATION = gql`
  mutation AcknowledgeNCNotifications($notificationId: String, $category: CategoryInput) {
    acknowledgeNCNotifications(notificationId: $notificationId, category: $category) {
      id
    }
  }
`;
